class StepsInfos {
  constructor() {
    if(document.querySelector('.steps-infos') != null && document.querySelector('.steps-infos') != undefined) {
      this.setEvents();
    };
  }

  setEvents() {
    var stepsInfos = document.querySelector('.steps-infos');
    var buttonsNextStep = document.querySelectorAll('[data-next-step]');
    var checkCC = document.getElementById('cc');
    var checkDC = document.getElementById('dc');
    var formCC = document.querySelector('[data-payment-type="cc"]');
    var formDC = document.querySelector('[data-payment-type="dc"]');

    checkCC.addEventListener('click', function() {
      formCC.classList.contains('active') ? null : formCC.classList.add('active');

      formDC.classList.contains('active') ? formDC.classList.remove('active') : null;
    });

    checkDC.addEventListener('click', function() {
      formDC.classList.contains('active') ? null : formDC.classList.add('active');

      formCC.classList.contains('active') ? formCC.classList.remove('active') : null;
    });

    buttonsNextStep.forEach(element => {
      element.addEventListener('click', function(e) {
        e.preventDefault();
        
        stepsInfos.setAttribute('data-active-step', this.getAttribute('data-next-step'));
      });
    });

    var checkbox = document.getElementById('check-condicoes');
    var btnCheckout = document.getElementById('checkout');

    btnCheckout.addEventListener('click', function(e) {
      e.preventDefault();
      
      if(!this.hasAttribute('disabled')) {
        window.location.href = this.getAttribute('href');
      }
    });

    checkbox.addEventListener('change', (event) => {
      if (event.target.checked) {
        btnCheckout.removeAttribute('disabled');
      } else {
        btnCheckout.setAttribute('disabled', 'disabled');
      }
    });

    if(window.location.href.includes('?step')) {
      stepsInfos.setAttribute('data-active-step', window.location.href.split('?step=')[1]);
    }
  }
}

$(document).ready(function() {
  const stepsInfos = new StepsInfos();
});